import styles from "./styles.module.scss";
import Link from "next/link";
import Image from "next/image";
import parse from "html-react-parser";
import { useWindowSize } from "../../../../utils/useWindowSize";
import { getMediaImage } from "../../../../utils/images";
import { MediaSize, MediaImage } from "../../../../types/MediaImage";
import { gaEvents } from "../../../../utils/ga_events";

export interface ComponentTypes {
  items: Array<Item>;
}

interface Item {
  excerpt: string;
  uri: string;
  slug: string;
  title: string;
  databaseId: number;
  featuredImage: MediaImage;
  date: Date;
  modified: Date;
  author: {
    node: {
      name: string;
    };
  };
}

export const BeneficiosGoverno = ({ items }: ComponentTypes) => {
  const size = useWindowSize();
  let numItemsByScreen = items;

  if (items.length > 0) {
    if (size.width < 1398) {
      numItemsByScreen = items.slice(0, 2);
    } else if (size.width > 1399) {
      numItemsByScreen = items.slice(0, 3);
    }
  }

  return (
    <>
      {numItemsByScreen.length > 0 &&
        numItemsByScreen.map((item) => {
          const excerptHMTL = parse(
            item.excerpt.replace(/(<([^>]+)>)/gi, "").substr(0, 140)
          );

          return (
            <div className={styles.cardContainer} key={item.databaseId}>
              <Link
                key={item.databaseId}
                className={styles.card}
                href={item.uri}
                passHref
                onClick={() => gaEvents.news.selectArticle(item)}
              >
                <div className={styles.imgContainer}>
                  <Image
                    placeholder="blur"
                    blurDataURL="/static-next/placeholder-image.png"
                    fill
                    alt={item.title}
                    title={item.title}
                    src={getMediaImage(item.featuredImage, MediaSize.MEDIUM)}
                  />
                </div>
                <div className={styles.textCard}>
                  <h3>{item.title}</h3>
                  <p>{excerptHMTL}</p>
                </div>
              </Link>
            </div>
          );
        })}
    </>
  );
};
